(function () {
  'use strict';

  if (window.__mnqLoaded) return;
  window.__mnqLoaded = true;

  var PORTAL_ID = '39596724';
  var FORM_ID   = '980a0b88-76e2-41d1-a5a5-e04961a16205';
  var SUBMIT_URL = 'https://api.hsforms.com/submissions/v3/integration/submit/' + PORTAL_ID + '/' + FORM_ID;

  var FILE_FORM_ID           = '55f38d14-a24d-48f3-94a7-b9e774cd2303';
  var FILE_FIELD              = 'arquivo_neo';
  var LEGACY_FILE_UPLOAD_URL  = 'https://forms.hubspot.com/uploads/form/v2/' + PORTAL_ID + '/' + FILE_FORM_ID;
  var MAX_FILE_MB = 100;
  var REDIRECT_URL = 'https://madesa.mx/pages/lp-neo-gracias';

  var submitted = false;
  var leadCaptured = false;

  var DATE_FIELD = 'cuando_piensas_realizar_tu_compra_del_placard_modular_arneo';

  var MEASURES_FIELD = 'medidas_del_cuarto_para_el_proyecto_planificado_arneo';

  var EXIT_FIELD = 'etapa_de_saida_do_quiz_neo_latam';

  var EXIT_STEP = {
    2: '2 - Elección del formato',
    3: '3 - Medidas del cuarto',
    4: '4 - Medida de la cama',
    5: '5 - Otros muebles',
    6: '6 - Espacio listo',
    7: '7 - Agendamiento',
    8: '8 - Inversión'
  };

  var CARD_COPY = {
    2: { title: 'Este paso ayuda a dar forma al clóset de tus sueños',
         sub:   'Elegir el formato es clave para mostrarte opciones que funcionen en tu espacio.',
         primary: 'Quiero elegir el formato' },
    3: { title: 'Con las medidas, el proyecto se ajusta a tu espacio',
         sub:   'Con las medidas de tu recámara, te sugerimos el clóset que mejor aprovecha el espacio.',
         primary: 'Quiero indicar las medidas' },
    4: { title: 'La cama define la distribución de toda la recámara',
         sub:   'Saber el tamaño de la cama nos ayuda a planificar la mejor distribución de los muebles.',
         primary: 'Quiero indicar la cama' },
    5: { title: 'Armemos el espacio completo',
         sub:   'Elegir los muebles complementarios acerca el proyecto a lo que te imaginas.',
         primary: 'Quiero elegir los muebles' },
    6: { title: 'Entender tu plazo agiliza la atención',
         sub:   'Saber si el espacio ya está listo nos ayuda a organizar el mejor momento para hablar contigo.',
         primary: 'Quiero responder' },
    7: { title: 'Te hablamos en el momento justo',
         sub:   'Si nos dices cuándo piensas comprar, te contactamos cerca de la fecha ideal.',
         primary: 'Quiero indicar la fecha' },
    8: { title: 'Te sugerimos opciones dentro de tu presupuesto',
         sub:   'Saber cuánto piensas invertir nos ayuda a presentarte las mejores opciones.',
         primary: 'Quiero indicar el monto' }
  };

  var HIDDEN_FIELDS = [
    { name: 'nacionalidade',                             value: 'México' },
    { name: 'qual_a_linha_que_voce_gostou_mais_',        value: 'Neo' },
    { name: 'origem_de_cadastro_staging',                value: 'LP GR Modulado (Quiz)' },
    { name: 'origem_de_cadastro__crm__staging',          value: 'LP GR Modulado (Quiz)' },
    { name: 'madesa_email_consent',                      value: 'true' },
    { name: 'fuente_de_registro__mexico_',               value: 'Quiz NEO' }
  ];

  var LEGAL_CONSENT = {
    consent: {
      consentToProcess: true,
      text: 'Para poder brindarte nuestro servicio, necesitamos tu autorización para almacenar y procesar tus datos personales.',
      communications: [
        { value: true, subscriptionTypeId: 2924505825, text: 'Acepto recibir otras comunicaciones de Madesa.' }
      ]
    }
  };

  var MSG = {
    required:   'Por favor, completa este campo para continuar.',
    email:      'Ingresa un correo electrónico válido.',
    phone:      'Ingresa un teléfono válido de 10 dígitos (lada + número).',
    pickOne:    'Selecciona una opción para continuar.',
    pickMany:   'Selecciona al menos una opción para continuar.',
    consent:    'Es necesario aceptar para continuar.',
    fileTooBig: 'Uno de los archivos supera los ' + MAX_FILE_MB + 'MB. Elige un archivo más pequeño.',
    fileRequired: 'Adjunta la medida de tu espacio para continuar.',
    dateRequired: 'Selecciona la fecha para continuar.',
    submitting: 'Enviando...',
    error:      'No pudimos enviar el formulario ahora. Intenta de nuevo en unos instantes.'
  };

  var BTN = {
    start:  'Comenzar',
    next:   'Continuar',
    skip:   'Omitir',
    submit: 'Enviar'
  };

  var FORMAT_FIELD = 'que_formato_de_placard_se_adapta_mejor_a_tu_espacio_arneo';
  var FORMAT_WALLS = { 'Lineal': 1, 'De esquina': 2, 'Paralelo': 2, 'En U': 3, 'Otro formato': 1 };

  function isEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  function formatPhoneMX(afterPrefix) {
    var digits = (afterPrefix || '').replace(/\D/g, '');

    if (digits.indexOf('52') === 0 && digits.length > 10) digits = digits.slice(2);
    if (digits.indexOf('044') === 0 || digits.indexOf('045') === 0) digits = digits.slice(3);
    else if (digits.indexOf('01') === 0 && digits.length > 10) digits = digits.slice(2);
    if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);

    digits = digits.slice(0, 10);

    var TWO_DIGIT_AREAS = ['55', '33', '81'];
    var areaLen = (TWO_DIGIT_AREAS.indexOf(digits.slice(0, 2)) !== -1) ? 2 : 3;
    var area = digits.slice(0, areaLen);
    var rest = digits.slice(areaLen);
    var out = area;
    if (rest) {
      out += ' ';
      if (rest.length <= 4) out += rest;
      else out += rest.slice(0, rest.length - 4) + '-' + rest.slice(-4);
    }
    return out;
  }

  var PHONE_PREFIX = '+52 ';
  var PHONE_MIN_DIGITS = 12;
  function isPhoneFilled(v) { return (v || '').replace(/\D/g, '').length >= PHONE_MIN_DIGITS; }

  function getHutk() {
    var m = document.cookie.match(/(^|;\s*)hubspotutk=([^;]*)/);
    return m ? m[2] : '';
  }

  function formatFileSize(bytes) {
    if (!bytes && bytes !== 0) return '';
    if (bytes < 1024) return bytes + ' B';
    var kb = bytes / 1024;
    if (kb < 1024) return Math.round(kb) + ' KB';
    return (kb / 1024).toFixed(1) + ' MB';
  }

  function submitFileViaHiddenIframe(email, files) {
    if (!files || !files.length) return;

    try {
      var IFRAME_NAME = 'mnq-file-upload-frame';
      var iframe = document.getElementById(IFRAME_NAME);
      if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.name = IFRAME_NAME;
        iframe.id = IFRAME_NAME;
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
      }

      var form = document.createElement('form');
      form.action = LEGACY_FILE_UPLOAD_URL;
      form.method = 'POST';
      form.enctype = 'multipart/form-data';
      form.target = IFRAME_NAME;
      form.style.display = 'none';

      var emailInput = document.createElement('input');
      emailInput.type = 'hidden';
      emailInput.name = 'email';
      emailInput.value = email || '';
      form.appendChild(emailInput);

      var ctxInput = document.createElement('input');
      ctxInput.type = 'hidden';
      ctxInput.name = 'hs_context';
      ctxInput.value = JSON.stringify({
        pageUri: window.location.href,
        pageName: document.title,
        hutk: getHutk()
      });
      form.appendChild(ctxInput);

      var fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.name = FILE_FIELD;
      fileInput.multiple = true;
      var dt = new DataTransfer();
      Array.prototype.forEach.call(files, function (f) { dt.items.add(f); });
      fileInput.files = dt.files;
      form.appendChild(fileInput);

      document.body.appendChild(form);
      form.submit();
      window.setTimeout(function () { form.remove(); }, 30000);
    } catch (err) {
      console.error('[NEO Quiz] Falha ao tentar enviar arquivo via iframe oculto — quiz principal segue normalmente.', err);
    }
  }

  function init(root) {
    var scope = root || document;
    var modal = scope.querySelector('[data-mnq-modal]');
    if (!modal || modal.dataset.mnqInit === 'true') return;
    var overlay = scope.querySelector('[data-mnq-overlay]');

    if (window.MadesaNeoQuiz && window.MadesaNeoQuiz.modal && document.body.contains(window.MadesaNeoQuiz.modal)) {
      modal.remove();
      if (overlay) overlay.remove();
      return;
    }
    modal.dataset.mnqInit = 'true';

    var body      = document.body;
    if (overlay && overlay.parentNode !== body) body.appendChild(overlay);
    if (modal.parentNode !== body) body.appendChild(modal);
    document.querySelectorAll('[data-mnq-modal], [data-mnq-overlay]').forEach(function (el) {
      if (el !== modal && el !== overlay) el.remove();
    });
    var header    = modal.querySelector('.mnq-header');
    var backBtn   = modal.querySelector('[data-mnq-back]');
    var nextBtn   = modal.querySelector('[data-mnq-next]');
    var progress  = modal.querySelector('[data-mnq-progress]');
    var progText  = modal.querySelector('[data-mnq-progress-text]');
    var progFill  = modal.querySelector('[data-mnq-progress-fill]');
    var statusEl  = modal.querySelector('[data-mnq-status]');
    var footer    = modal.querySelector('.mnq-footer');

    var confirmEl   = modal.querySelector('[data-mnq-confirm]');
    var cfTitle     = modal.querySelector('[data-confirm-title]');
    var cfSub       = modal.querySelector('[data-confirm-sub]');
    var cfPrimary   = modal.querySelector('[data-confirm-primary]');
    var cfPrimaryLb = modal.querySelector('[data-confirm-primary-label]');
    var cfSkip      = modal.querySelector('[data-confirm-skip]');
    var cfExit      = modal.querySelector('[data-confirm-exit]');

    var steps = Array.prototype.slice.call(modal.querySelectorAll('.mnq-step'));
    var isQuestion = function (s) { return s.dataset.stepKind === 'question'; };
    var questions = steps.filter(isQuestion);
    var totalQ = questions.length;
    var current = 0;

    function successIndex() {
      return steps.findIndex(function (s) { return s.dataset.stepKind === 'success'; });
    }

    var monthInput = modal.querySelector('input[type="month"][data-hs-field]');
    if (monthInput) {
      var now = new Date();
      var mm = String(now.getMonth() + 1).padStart(2, '0');
      monthInput.min = now.getFullYear() + '-' + mm;
      monthInput.max = (now.getFullYear() + 1) + '-12';
    }

    function scrollbarW() { return window.innerWidth - document.documentElement.clientWidth; }

    function open(e) {
      if (e) e.preventDefault();
      overlay.hidden = false; modal.hidden = false;
      void modal.offsetWidth;
      var sb = scrollbarW(); if (sb > 0) body.style.paddingRight = sb + 'px';
      body.classList.add('mnq-open');
      overlay.classList.add('is-open');
      modal.classList.add('is-open');
      hideConfirm();
      if (submitted) {
        var si = successIndex();
        goTo(si > -1 ? si : 0);
      } else {
        goTo(current);
      }
    }
    function close() {
      hideConfirm();
      overlay.classList.remove('is-open');
      modal.classList.remove('is-open');
      body.classList.remove('mnq-open');
      body.style.paddingRight = '';
      window.setTimeout(function () { modal.hidden = true; overlay.hidden = true; }, 320);
    }

    function showStatus(msg) {
      if (!statusEl) return;
      statusEl.hidden = false;
      statusEl.textContent = msg;
    }
    function clearStatus() {
      if (!statusEl) return;
      statusEl.hidden = true; statusEl.textContent = '';
    }

    function questionIndexOf(stepEl) {
      return questions.indexOf(stepEl);
    }
    function currentQi() {
      var step = steps[current];
      return (step && step.dataset.stepKind === 'question') ? questionIndexOf(step) + 1 : 0;
    }

    function render() {
      var step = steps[current];
      var kind = step.dataset.stepKind;

      steps.forEach(function (s) { s.classList.toggle('is-active', s === step); });
      hideConfirm();

      var isQ = kind === 'question';
      header.classList.toggle('is-step', isQ);
      if (progress) progress.hidden = !isQ;

      if (isQ) {
        var qi = questionIndexOf(step) + 1;
        if (progText) progText.textContent = qi + ' de ' + totalQ;
        if (progFill) progFill.style.width = Math.round((qi / totalQ) * 100) + '%';
      }

      var label = BTN.next;
      if (kind === 'welcome') label = BTN.start;
      else if (kind === 'question' && questionIndexOf(step) === totalQ - 1) label = BTN.submit;
      if (nextBtn) {
        nextBtn.querySelector('[data-mnq-next-label]').textContent = label;
        nextBtn.classList.remove('mnq-btn--outline');
      }

      var isMedidas = step.hasAttribute('data-step-medidas');
      if (isMedidas) setupMedidas(step);
      var isOptional = !!step.querySelector('[data-optional-radio]');
      if (isOptional) updateOptionalRadioLabel(step);
      if (!isMedidas && !isOptional) updateRequiredButtonState(step);

      if (footer) footer.hidden = (kind === 'success');

      clearStatus();
    }

    function isStepAnswered(step) {
      var groups = step.querySelectorAll('[data-hs-required="true"]');
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i];
        var type = g.getAttribute('data-hs-group') || '';
        if (type === 'radio' || type === 'checkbox') {
          if (g.querySelectorAll('input:checked').length === 0) return false;
        } else if (type === 'consent') {
          var c = g.querySelector('input[type="checkbox"]');
          if (!c || !c.checked) return false;
        } else {
          var input = g.querySelector('input, textarea, select');
          var val = (input && input.value ? input.value : '').trim();
          if (!val) return false;
          if (input.type === 'email' && !isEmail(val)) return false;
          if (input.type === 'tel' && !isPhoneFilled(val)) return false;
        }
      }
      return true;
    }
    function updateRequiredButtonState(step) {
      if (!nextBtn) return;
      var hasRequired = step.querySelectorAll('[data-hs-required="true"]').length > 0;
      if (!hasRequired) { nextBtn.disabled = false; nextBtn.classList.remove('mnq-btn--disabled'); return; }
      var ok = isStepAnswered(step);
      nextBtn.disabled = !ok;
      nextBtn.classList.toggle('mnq-btn--disabled', !ok);
    }

    function updateOptionalRadioLabel(step) {
      var grp = step.querySelector('[data-optional-radio]');
      if (!grp) return;
      nextBtn.disabled = false;
      nextBtn.classList.remove('mnq-btn--disabled');
      var checked = grp.querySelector('input:checked');
      var lbl = nextBtn.querySelector('[data-mnq-next-label]');
      if (checked) {
        lbl.textContent = (questionIndexOf(step) === totalQ - 1) ? BTN.submit : BTN.next;
        nextBtn.classList.remove('mnq-btn--outline');
      } else {
        lbl.textContent = BTN.skip;
        nextBtn.classList.add('mnq-btn--outline');
      }
    }

    function getSelectedFormat() {
      var r = modal.querySelector('input[data-hs-field="' + FORMAT_FIELD + '"]:checked');
      return r ? r.value : '';
    }
    function setupMedidas(step) {
      var fmt = getSelectedFormat();
      var isOther = (fmt === 'Otro formato');
      var walls = isOther ? 0 : (FORMAT_WALLS[fmt] || 1);

      step.querySelectorAll('[data-diag]').forEach(function (d) {
        d.hidden = isOther || (d.getAttribute('data-diag') !== fmt);
      });
      step.querySelectorAll('[data-wall]').forEach(function (w) {
        w.hidden = isOther || (+w.getAttribute('data-wall') > walls);
      });
      var medidasBlock = step.querySelector('.mnq-medidas');
      if (medidasBlock) medidasBlock.hidden = isOther;

      var titleEl = step.querySelector('[data-medidas-title]');
      if (titleEl) {
        titleEl.textContent = isOther
          ? 'Adjunta aquí la medida de tu espacio'
          : '¿Cuál es la medida de tu espacio?';
      }

      syncMeasures(step);
      updateMedidasLabel(step);
    }
    function updateMedidasLabel(step) {
      var fmt = getSelectedFormat();
      var isOther = (fmt === 'Otro formato');
      var hasFile = uploadFiles.length > 0;
      var lbl = nextBtn.querySelector('[data-mnq-next-label]');

      if (isOther) {
        lbl.textContent = BTN.next;
        nextBtn.classList.remove('mnq-btn--outline');
        nextBtn.disabled = !hasFile;
        nextBtn.classList.toggle('mnq-btn--disabled', !hasFile);
        return;
      }

      nextBtn.disabled = false;
      nextBtn.classList.remove('mnq-btn--disabled');
      var filled = hasFile;
      step.querySelectorAll('[data-wall]').forEach(function (w) {
        if (w.hidden) return;
        var inp = w.querySelector('[data-wall-input]');
        if (inp && inp.value.trim()) filled = true;
      });
      if (filled) { lbl.textContent = BTN.next; nextBtn.classList.remove('mnq-btn--outline'); }
      else { lbl.textContent = BTN.skip; nextBtn.classList.add('mnq-btn--outline'); }
    }

    function syncMeasures(step) {
      var parts = [];
      step.querySelectorAll('[data-wall]').forEach(function (w) {
        if (w.hidden) return;
        var inp = w.querySelector('[data-wall-input]');
        var val = inp ? (inp.value || '').trim() : '';
        if (!val) return;
        var labelEl = w.querySelector('.mnq-wall__label');
        var label = labelEl
          ? labelEl.textContent.replace(/[:\s]+$/, '').trim()
          : ('Pared ' + w.getAttribute('data-wall'));
        parts.push(label + ': ' + val + ' cm');
      });
      var hid = step.querySelector('input[data-hs-field="' + MEASURES_FIELD + '"]');
      if (hid) hid.value = parts.join(' | ');
    }

    function goTo(i) {
      current = Math.max(0, Math.min(i, steps.length - 1));
      render();
    }

    function goBack() {
      if (current > 0) goTo(current - 1);
    }

    function goNext() {
      var step = steps[current];
      if (step.dataset.stepKind === 'question' && !validateStep(step)) return;

      if (step.dataset.stepKind === 'question' && questionIndexOf(step) === 0) {
        captureLead();
      }

      var isLastQuestion = step.dataset.stepKind === 'question'
        && questionIndexOf(step) === totalQ - 1;
      if (isLastQuestion) { submit(); return; }

      goTo(current + 1);
    }

    function validateStep(step) {
      clearStatus();
      var groups = step.querySelectorAll('[data-hs-required="true"]');
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i];
        var type = g.getAttribute('data-hs-group') || '';

        if (type === 'radio' || type === 'checkbox') {
          var checked = g.querySelectorAll('input:checked').length;
          if (checked === 0) {
            showStatus(type === 'radio' ? MSG.pickOne : MSG.pickMany);
            g.scrollIntoView({ block: 'center', behavior: 'smooth' });
            return false;
          }
        } else if (type === 'consent') {
          var c = g.querySelector('input[type="checkbox"]');
          if (!c || !c.checked) { showStatus(MSG.consent); return false; }
        } else {
          var input = g.querySelector('input, textarea, select');
          var val = (input && input.value ? input.value : '').trim();
          if (!val) { showStatus(MSG.required); input && input.focus(); return false; }
          if (input.type === 'email' && !isEmail(val)) { showStatus(MSG.email); input.focus(); return false; }
          if (input.type === 'tel' && !isPhoneFilled(val)) { showStatus(MSG.phone); input.focus(); return false; }
        }
      }
      return true;
    }

    function collect() {
      var out = {};
      modal.querySelectorAll('[data-hs-field]').forEach(function (el) {
        var name = el.getAttribute('data-hs-field');
        if (el.type === 'checkbox') {
          if (!out[name]) out[name] = [];
          if (el.checked) out[name].push(el.value);
        } else if (el.type === 'radio') {
          if (el.checked) out[name] = el.value;
        } else {
          out[name] = el.value;
        }
      });
      return out;
    }

    function buildFields(extra) {
      var raw = collect();
      var fields = [];
      Object.keys(raw).forEach(function (name) {
        var v = raw[name];
        if (Array.isArray(v)) v = v.join(';');
        if (name === DATE_FIELD && v) {
          var p = v.split('-');
          var d = p[2] ? +p[2] : 1;
          v = String(Date.UTC(+p[0], +p[1] - 1, d));
        }
        if (name === 'phone' && v) v = v.replace(/\D/g, '');
        if (v !== '' && v != null) fields.push({ name: name, value: String(v) });
      });
      HIDDEN_FIELDS.forEach(function (f) { fields.push(f); });
      if (extra) extra.forEach(function (f) {
        if (f && f.value !== '' && f.value != null) fields.push(f);
      });
      return fields;
    }

    function postToHubspot(fields, ipAddress) {
      var ctx = { pageUri: window.location.href, pageName: document.title };
      var hutk = getHutk();
      if (hutk) ctx.hutk = hutk;
      if (ipAddress) ctx.ipAddress = ipAddress;

      var payload = {
        fields: fields,
        context: ctx,
        legalConsentOptions: LEGAL_CONSENT
      };

      return fetch(SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok) {
            console.error('[NEO Quiz] Falha no envio', res.status, data);
            throw new Error((data && data.message) || MSG.error);
          }
          return data;
        });
      });
    }

    function captureLead() {
      if (leadCaptured) return;
      leadCaptured = true;
      try {
        postToHubspot(buildFields()).catch(function (err) {
          console.error('[NEO Quiz] Captação inicial do lead falhou (o quiz segue normalmente).', err);
        });
      } catch (err) {
        console.error('[NEO Quiz] Erro inesperado na captação inicial do lead.', err);
      }
    }

    function recordExit(stepValue) {
      try {
        var medStep = modal.querySelector('[data-step-medidas]');
        if (medStep) syncMeasures(medStep);
        postToHubspot(buildFields([{ name: EXIT_FIELD, value: stepValue }]))
          .catch(function (err) {
            console.error('[NEO Quiz] Registro da etapa de saída falhou.', err);
          });
      } catch (err) {
        console.error('[NEO Quiz] Erro inesperado ao registrar etapa de saída.', err);
      }
    }

    function showConfirm(qi) {
      var copy = CARD_COPY[qi];
      if (!copy || !confirmEl) { close(); return; }
      if (cfTitle)     cfTitle.textContent = copy.title;
      if (cfSub)       cfSub.textContent = copy.sub;
      if (cfPrimaryLb) cfPrimaryLb.textContent = copy.primary;
      if (cfSkip) cfSkip.hidden = uploadRequiredMissing() || isDateStep();
      confirmEl.hidden = false;
      confirmEl.classList.add('is-open');
    }
    function hideConfirm() {
      if (!confirmEl) return;
      confirmEl.classList.remove('is-open');
      confirmEl.hidden = true;
    }

    function requestClose() {
      var qi = currentQi();
      if (qi >= 2) { showConfirm(qi); return; }
      close();
    }

    function uploadRequiredMissing() {
      var step = steps[current];
      if (!step || !step.hasAttribute('data-step-medidas')) return false;
      if (getSelectedFormat() !== 'Otro formato') return false;
      return uploadFiles.length === 0;
    }

    function isDateStep() {
      var step = steps[current];
      return !!(step && step.querySelector('input[type="month"]'));
    }

    function skipQuestion() {
      if (isDateStep()) {
        hideConfirm();
        showStatus(MSG.dateRequired);
        return;
      }
      if (uploadRequiredMissing()) {
        hideConfirm();
        showStatus(MSG.fileRequired);
        return;
      }
      hideConfirm();
      var step = steps[current];
      var isLast = step.dataset.stepKind === 'question' && questionIndexOf(step) === totalQ - 1;
      if (isLast) { submit(); return; }
      goTo(current + 1);
    }

    function confirmExit() {
      var qi = currentQi();
      hideConfirm();
      recordExit(EXIT_STEP[qi] || '');
      close();
    }

    function submit() {
      clearStatus();

      if (submitted) {
        var siAlready = successIndex();
        if (siAlready > -1) goTo(siAlready);
        return;
      }

      if (uploadInput && uploadInput.files && uploadInput.files.length) {
        var oversized = Array.prototype.some.call(uploadInput.files, function (f) {
          return f.size > MAX_FILE_MB * 1024 * 1024;
        });
        if (oversized) { showStatus(MSG.fileTooBig); return; }
      }

      var emailField = modal.querySelector('[data-hs-field="email"]');
      if (uploadInput && uploadInput.files && uploadInput.files.length) {
        try {
          submitFileViaHiddenIframe(emailField ? emailField.value : '', uploadInput.files);
        } catch (err) {
          console.error('[NEO Quiz] Erro inesperado ao disparar upload de arquivo.', err);
        }
      }

      nextBtn.disabled = true;
      nextBtn.querySelector('[data-mnq-next-label]').textContent = MSG.submitting;

      var finish = function () {
        nextBtn.disabled = false;
        render();
      };

      var getIp = fetch('https://api.ipify.org?format=json')
        .then(function (r) { return r.json(); })
        .then(function (d) { return d.ip; })
        .catch(function () { return ''; });

      var medStep = modal.querySelector('[data-step-medidas]');
      if (medStep) syncMeasures(medStep);

      getIp.then(function (ip) {
        return postToHubspot(buildFields([{ name: EXIT_FIELD, value: 'Concluído' }]), ip);
      })
      .then(function () {
        submitted = true;
        try {
          window.dispatchEvent(new CustomEvent('mnq:submitted', { detail: { formId: FORM_ID } }));
        } catch (e) {}
        var si = successIndex();
        if (si > -1) goTo(si); else finish();
        window.location.href = REDIRECT_URL;
      })
      .catch(function (err) {
        showStatus(err.message || MSG.error);
        finish();
      });
    }

    modal.querySelectorAll('[data-mnq-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); requestClose(); });
    });
    if (backBtn) backBtn.addEventListener('click', function (e) { e.preventDefault(); goBack(); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); goNext(); });

    if (cfPrimary) cfPrimary.addEventListener('click', function (e) { e.preventDefault(); hideConfirm(); });
    if (cfSkip)    cfSkip.addEventListener('click', function (e) { e.preventDefault(); skipQuestion(); });
    if (cfExit)    cfExit.addEventListener('click', function (e) { e.preventDefault(); confirmExit(); });
    if (confirmEl) confirmEl.addEventListener('click', function (e) { if (e.target === confirmEl) hideConfirm(); });

    modal.querySelectorAll('[data-hs-required] input, [data-hs-required] textarea, [data-hs-required] select').forEach(function (el) {
      var reeval = function () {
        var st = el.closest('.mnq-step');
        if (st) updateRequiredButtonState(st);
      };
      el.addEventListener('input', reeval);
      el.addEventListener('change', reeval);
    });

    var phoneInput = modal.querySelector('[data-hs-field="phone"]');
    if (phoneInput) {
      if (!phoneInput.value || phoneInput.value.indexOf(PHONE_PREFIX) !== 0) {
        phoneInput.value = PHONE_PREFIX;
      }

      var applyPhoneMask = function () {
        var v = phoneInput.value;
        var afterPrefix;
        if (v.indexOf(PHONE_PREFIX) === 0) {
          afterPrefix = v.slice(PHONE_PREFIX.length);
        } else {
          var d = v.replace(/\D/g, '');
          if (d.indexOf('52') === 0) d = d.slice(2);
          afterPrefix = d;
        }
        phoneInput.value = PHONE_PREFIX + formatPhoneMX(afterPrefix);
      };

      phoneInput.addEventListener('input', applyPhoneMask);

      phoneInput.addEventListener('keydown', function (e) {
        var pos = phoneInput.selectionStart;
        if (e.key === 'Backspace' && pos <= PHONE_PREFIX.length &&
            phoneInput.selectionEnd <= PHONE_PREFIX.length) {
          e.preventDefault();
        }
      });

      phoneInput.addEventListener('focus', function () {
        if (phoneInput.value.length < PHONE_PREFIX.length) phoneInput.value = PHONE_PREFIX;
        var end = phoneInput.value.length;
        try { phoneInput.setSelectionRange(Math.max(PHONE_PREFIX.length, end), end); } catch (e) {}
      });
    }

    modal.querySelectorAll('[data-optional-radio] input').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var st = inp.closest('.mnq-step');
        if (st) updateOptionalRadioLabel(st);
      });
    });

    var furnGroup = modal.querySelector('[data-furniture-group]');
    if (furnGroup) {
      var furnCards = furnGroup.querySelector('.mnq-furncards');
      var noneInput = furnGroup.querySelector('[data-furn-none]');
      var furnInputs = furnGroup.querySelectorAll('[data-furn]');
      if (noneInput) {
        noneInput.addEventListener('change', function () {
          if (noneInput.checked) {
            furnInputs.forEach(function (f) { f.checked = false; });
            if (furnCards) furnCards.classList.add('is-none-selected');
          } else {
            if (furnCards) furnCards.classList.remove('is-none-selected');
          }
        });
      }
      furnInputs.forEach(function (f) {
        f.addEventListener('change', function () {
          if (f.checked && noneInput) {
            noneInput.checked = false;
            if (furnCards) furnCards.classList.remove('is-none-selected');
          }
        });
      });
    }

    modal.querySelectorAll('[data-wall-input]').forEach(function (inp) {
      inp.addEventListener('input', function () {
        var st = inp.closest('[data-step-medidas]');
        if (!st) return;
        syncMeasures(st);
        updateMedidasLabel(st);
      });
    });

    var uploadInput = modal.querySelector('[data-upload]');
    var uploadFiles = [];

    function syncUploadInputFromArray() {
      if (!uploadInput) return;
      var dt = new DataTransfer();
      uploadFiles.forEach(function (f) { dt.items.add(f); });
      uploadInput.files = dt.files;
    }

    function renderUploadList(step) {
      if (!step) return;
      var listEl = step.querySelector('[data-upload-list]');
      var nameEl = step.querySelector('[data-upload-name]');
      if (!listEl) return;

      listEl.innerHTML = '';

      if (!uploadFiles.length) {
        listEl.hidden = true;
        if (nameEl) nameEl.textContent = 'Ningún archivo seleccionado';
        return;
      }

      if (nameEl) {
        nameEl.textContent = uploadFiles.length === 1
          ? uploadFiles[0].name
          : uploadFiles.length + ' archivos seleccionados';
      }

      uploadFiles.forEach(function (file, idx) {
        var li = document.createElement('li');
        li.className = 'mnq-upload__item';

        var info = document.createElement('span');
        info.className = 'mnq-upload__item-info';

        var nameSpan = document.createElement('span');
        nameSpan.className = 'mnq-upload__item-name';
        nameSpan.textContent = file.name;

        var sizeSpan = document.createElement('span');
        sizeSpan.className = 'mnq-upload__item-size';
        sizeSpan.textContent = formatFileSize(file.size);

        info.appendChild(nameSpan);
        info.appendChild(sizeSpan);

        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'mnq-upload__item-remove';
        removeBtn.setAttribute('aria-label', 'Eliminar ' + file.name);
        removeBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>';
        removeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          uploadFiles.splice(idx, 1);
          syncUploadInputFromArray();
          renderUploadList(step);
          updateMedidasLabel(step);
        });

        li.appendChild(info);
        li.appendChild(removeBtn);
        listEl.appendChild(li);
      });

      listEl.hidden = false;
    }

    if (uploadInput) uploadInput.addEventListener('change', function () {
      var st = uploadInput.closest('[data-step-medidas]');
      if (uploadInput.files && uploadInput.files.length) {
        Array.prototype.forEach.call(uploadInput.files, function (f) { uploadFiles.push(f); });
        syncUploadInputFromArray();
      }
      renderUploadList(st);
      updateMedidasLabel(st);
    });

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
        e.preventDefault();
        if (confirmEl && confirmEl.classList.contains('is-open')) return;
        goNext();
      }
    });

    window.addEventListener('beforeunload', function (e) {
      if (submitted || !modal.classList.contains('is-open')) return;
      if (currentQi() < 1) return;
      e.preventDefault();
      e.returnValue = '';
      return '';
    });

    window.MadesaNeoQuiz = { open: open, close: close, modal: modal, overlay: overlay };
  }

  var OPEN_HASHES = ['#abrir-quiz-neo', '#quiz-neo'];

  function isHashTrigger(el) {
    if (!el) return false;
    var raw = (el.getAttribute && el.getAttribute('href')) || '';
    var hash = el.hash || '';
    return OPEN_HASHES.some(function (h) {
      return hash === h || raw === h || raw.slice(-h.length) === h;
    });
  }

  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    var trigger = e.target.closest('.js-madesa-popup-open');
    if (!trigger) {
      var link = e.target.closest('a[href]');
      if (isHashTrigger(link)) trigger = link;
    }
    if (!trigger) return;
    e.preventDefault();
    if (window.MadesaNeoQuiz) window.MadesaNeoQuiz.open();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  document.addEventListener('shopify:section:unload', function (e) {
    var api = window.MadesaNeoQuiz;
    if (!api || !e.target.querySelector('[data-mnq-section]')) return;
    document.body.classList.remove('mnq-open');
    document.body.style.paddingRight = '';
    if (api.modal) api.modal.remove();
    if (api.overlay) api.overlay.remove();
    window.MadesaNeoQuiz = null;
  });
})();
